export enum ChallengeSetAction {
    TITLE = 'title',
    DESCRIPTION = 'description',
    CHALLENGE_IDS = 'challenge-ids',
    FEATURED = 'featured',
  }